<template>
  <div
    @mouseleave="hover = false"
    @mouseover="
      hover = true;
      colourHoverSwitch();
    "
    class="mb-3 subtleshadow carditem"
    ref="carditem"
    style="min-height: 110px"
    :style="`
        position: relative;
        border-radius: 5px;
        background: ${styling.backgroundHover};
        box-shadow: ${styling.mainShadow}!important;
        display: flex;
        align-items: center;
        justify-content: start;
        min-height: ${styling.minHeight}px;
        height: ${styling.height}px;
        cursor: pointer;
        display: flex;
        align-items: stretch;
        user-select: none;`"
    @mouseup="colourToggle()"
    @mouseout="colourOutSwitch()">
    <slot name="backgroundOverlay"></slot>
    <slot name="backgroundgraphics"></slot>
    <!-- Thumbnail -->
    <div
      v-if="loading"
      class="mx-2"
      :style="`display: flex;
          align-content: center;
          align-items: center;
          justify-content: center;
          height: 98px;
          color: rgb(var(--v-theme-text));
          width: 136px;
          border-radius: 5px;`">
      <v-progress-circular
        indeterminate
        color="grey"></v-progress-circular>
    </div>
    <!-- Thumbnail Grid (for AssetGroups with multiple thumbnails) - only show when not loading -->
    <div
      v-else-if="thumbnails && thumbnails.length > 0"
      class="mx-2 my-2 thumbnail-grid-clickable"
      @click.stop="$emit('thumbnail-click')"
      :style="`width: ${styling.thumbnailWidth}px; margin-left: ${styling.imageMargin} !important; background: #171717; border-radius: 5px; overflow: hidden; display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(2, 1fr); gap: 2px; padding: 2px; cursor: pointer;`">
      <div
        v-for="(thumb, idx) in thumbnails.slice(0, 4)"
        :key="idx"
        style="
          position: relative;
          overflow: hidden;
          border-radius: 3px;
          background: #1a1a1f;
        ">
        <img
          v-if="thumb.preview_static_small"
          decoding="async"
          style="width: 100%; height: 100%; object-fit: cover"
          :src="thumb.preview_static_small" />
        <div
          v-else
          style="
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
          ">
          <v-icon
            color="white"
            style="opacity: 0.3; font-size: 20px">
            mdi-image-off
          </v-icon>
        </div>
      </div>
    </div>

    <!-- Single Thumbnail - only show when not loading -->
    <div
      class="mx-2 my-2 preview-container"
      :style="`width: ${styling.thumbnailWidth}px; margin-left: ${styling.imageMargin} !important;`"
      v-else-if="img">
      <video
        v-if="vid && hover"
        style="
          height: 100%;
          width: 136px;
          object-fit: cover;
          position: absolute;
        "
        v-show="vid_loaded && hover"
        @loadeddata="vid_loaded = true"
        @error="onVideoError"
        muted
        autoplay
        loop
        :src="vidSrc" />
      <Transition>
        <img
          decoding="async"
          style="
            height: 100%;
            width: 136px;
            object-fit: cover;
            background: #171717;
          "
          :style="`width: ${styling.thumbnailWidth}px;`"
          @load="img_loaded = true"
          v-show="img_loaded"
          v-if="img"
          :src="img" />
      </Transition>
    </div>
    <div
      v-else-if="icon"
      class="mx-2 my-2"
      @click.stop="$emit('thumbnail-click')"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        width: 136px;
        background: #171717;
        border-radius: 5px;
        overflow: hidden;
        cursor: pointer;
      "
      :style="`width: ${styling.thumbnailWidth}px !important; margin-left: ${styling.imageMargin} !important;`">
      <v-icon
        color="white"
        style="opacity: 0.5; font-size: 50px !important">
        {{ icon }}
      </v-icon>
    </div>
    <div
      v-else
      class="mx-2 my-2"
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        width: 136px;
        background: #171717;
        border-radius: 5px;
        overflow: hidden;
      "
      :style="`width: ${styling.thumbnailWidth}px !important; margin-left: ${styling.imageMargin} !important;`">
      <v-icon
        color="white"
        style="opacity: 0.5; height: 98px; width: 136px">
        mdi-help-circle
      </v-icon>
    </div>

    <!-- content -->
    <div
      style="
        display: flex;
        flex-direction: column;
        width: 100%;
        flex: 1;
        overflow: auto;
        overflow-y: hidden;
      ">
      <div
        :style="`
            z-index: 10;
            border-radius: 5px;
            height: 35px;
            display: flex;
            justify-content: start;
            align-content: center;
            margin-top: 8px;
            background: ${styling.titleBackground};
            margin-bottom: ${styling.titleMargin} !important;
            align-items: center;
            padding-left: ${styling.tagPaddingLeft}px !important;
          `"
        class="mb-2 mr-2 px-3 widecard-title-container">
        <v-btn
          v-if="typeof prefixtitle === 'string' && prefixtitle.length > 0"
          variant="flat"
          :color="'var(--primary-color)'"
          class="mr-2 widecard-prefix"
          :style="{
            color: prefixColor ? prefixColor : '#5d6ae3',
            background: prefixBackgroundColor
              ? prefixBackgroundColor
              : 'rgb(58 64 125 / 19%)',
          }">
          {{ prefixtitle }}
        </v-btn>
        <div
          style="display: flex"
          v-if="typeof prefixtitle === 'object' && prefixtitle.length > 0">
          <div v-for="(prefix, index) in prefixtitle">
            <v-btn
              v-if="prefix"
              variant="flat"
              :color="'var(--primary-color)'"
              class="mr-2 widecard-prefix"
              :style="{
                color: prefixColor ? prefixColor : '#5d6ae3',
                background: prefixBackgroundColor
                  ? prefixBackgroundColor
                  : 'rgb(58 64 125 / 19%)',
              }">
              {{ prefix }}
            </v-btn>
          </div>
        </div>
        <div
          class="widecard-title"
          :style="`
              display: inline;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              color: ${styling.titleColour};
              font-family: 'Montserrat';
              font-weight: 400;
            `">
          <v-icon
            v-for="icon in icons"
            :key="icon"
            style="opacity: 0.7"
            class="mr-2"
            :color="getIconColor(icon)">
            {{ getIconName(icon) }}
          </v-icon>
          {{ title }}
        </div>
      </div>
      <div style="display: flex; min-width: 0">
        <div
          ref="WideCardTitle"
          :style="`
              display: flex;
              position: relative;
              background: ${styling.tagColour};
              box-shadow: ${styling.tagShadow} !important;
              border-radius: 5px;
              min-height: 53px;
              align-items: center;
              padding-left: ${styling.tagPaddingLeft}px !important;
              overflow: hidden;
              margin-bottom: 8px;
              flex: 1;
              padding-top: ${styling.tagPadding} !important;
              min-height: ${styling.tagHeight} !important;
            `"
          class="px-2 pt-2 mr-2 tag-parent">
          <slot></slot>
          <div
            v-if="tag == true"
            class="overflow-overlay"
            :style="`background: linear-gradient( 270deg, ${styling.overflowColour} 5%, #47474b00 60% ); opacity: ${styling.gradientOpacity};`"
            :id="'gradient' + title"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { onBeforeMount, ref, watch, reactive, onUpdated, computed } from 'vue';
import { state, deluge } from '../../stores/deluge.js';

const props = defineProps([
  'loading',
  'img',
  'vid',
  'title',
  'prefixtitle',
  'icon',
  'icons',
  'selected',
  'tag',
  'dense',
  'NDIName',
  'prefixColor',
  'prefixBackgroundColor',
  'thumbnails', // Array of {preview_static_small, preview_motion_small} for grid display
]);

const ndiConnected = computed(() => {
  return deluge?.ndi?.connected_streams?.includes(props.NDIName);
});

const icons = computed(() => {
  const iconsCopy = [];

  if (props.NDIName) {
    if (ndiConnected.value)
      iconsCopy.push({ icon: 'mdi-wifi', color: 'primary' });
    else iconsCopy.push({ icon: 'mdi-wifi-off' });
  }

  if (!props.icons) return [...iconsCopy];

  // Normalize icons to objects if they're strings
  const normalizedIcons = props.icons.map((icon) => {
    if (typeof icon === 'string') {
      return { icon: icon };
    }
    return icon;
  });

  return [...iconsCopy, ...normalizedIcons];
});

function getIconName(icon) {
  return typeof icon === 'string' ? icon : icon.icon;
}

function getIconColor(icon) {
  if (typeof icon === 'string') {
    return iconColour(icon);
  }
  return icon.color || iconColour(icon.icon);
}

function iconColour(icon) {
  const iconName = typeof icon === 'string' ? icon : icon.icon;
  if (iconName === 'mdi-wifi') return 'primary';
  // if (iconName === 'mdi-wifi-off') return 'red';
  return styling.titleColour;
}

const WideCardTitle = ref(null);
onUpdated(() => {
  checkOverflowing();
});
function checkOverflowing() {
  if (WideCardTitle.value) {
    if (WideCardTitle.value.scrollWidth > WideCardTitle.value.clientWidth) {
      styling.gradientOpacity = 1;
      return true;
    }
  }
  styling.gradientOpacity = 0;
  return true;
}
const styling = reactive({
  gradientOpacity: 0,
  height: 110,
  minHeight: 110,
  marginUnderneath: '15px',
  thumbnailWidth: 136,
  backgroundHover: 'rgb(var(--v-theme-cardColor))',
  titleBackground: 'rgb(var(--v-theme-titleBackground))',
  titleColour: 'rgb(var(--v-theme-titleBackground))',
  titleMargin: '',
  tagPadding: '',
  tagPaddingLeft: 8,
  tagHeight: '',
  tagColour: '#e0e0e036',
  tagShadow: 'rgb(0 0 0 / 8%) 0px 0px 24px inset',
  overflowColour: 'rgb(var(--v-theme-cardColorAlt))',
  imageMargin: '',
  tag: 'true',
  mainShadow: '',
  primary: 'rgb(var(--v-theme-primary))',
});
const img_loaded = ref(false);
const vid_loaded = ref(false);
const hover = ref(false);
const vidFallback = ref(false);

/** Resolved video src — falls back to .webm for pre-migration assets. */
const vidSrc = computed(() => {
  if (!props.vid) return '';
  const base = state.devRedirect + state.$ident + props.vid;
  if (vidFallback.value) {
    return base.replace(/\.mp4$/, '.webm');
  }
  return base;
});

/** If the .mp4 motion thumbnail fails, retry with .webm for legacy assets. */
function onVideoError() {
  if (!vidFallback.value && props.vid?.endsWith('.mp4')) {
    vidFallback.value = true;
  }
}
const carditem = ref(null);

watch(
  () => props.selected,
  () => {
    checkSelected();
  }
);
function checkSelected() {
  if (props.selected) {
    styling.backgroundHover = 'rgb(var(--v-theme-primary)) !important';
    styling.titleColour = 'white !important';
    styling.overflowColour = 'rgb(var(--v-theme-primary))';
  } else {
    styling.backgroundHover = 'rgb(var(--v-theme-cardColor))';
    styling.titleColour = 'rgb(var(--v-theme-titleBackground))';
    styling.overflowColour = 'rgb(var(--v-theme-cardColorAlt))';

    if (props.dense) {
      styling.titleColour = 'rgb(var(--v-theme-text))';
      styling.overflowColour = 'rgb(var(--v-theme-cardColor))';
    }
  }
}
function colourHoverSwitch() {
  if (props.dense) {
    if (props.selected) {
      styling.overflowColour = 'rgb(var(--v-theme-primary))';
    } else {
      styling.overflowColour = '#7680e0';
    }
  } else {
    if (props.selected) {
      styling.overflowColour = 'green';
    } else {
      styling.overflowColour = '#7680e0';
    }
  }
}

function colourOutSwitch() {
  if (props.dense) {
    if (props.selected) {
      styling.overflowColour = 'rgb(var(--v-theme-primary))';
    } else {
      styling.overflowColour = 'rgb(var(--v-theme-cardColor))';
    }
  } else {
    if (props.selected) {
      styling.overflowColour = 'green';
    } else {
      styling.overflowColour = 'rgb(var(--v-theme-cardColorAlt))';
    }
  }
}

function colourToggle() {
  if (props.dense) {
    if (props.selected) {
      styling.overflowColour = 'red';
    } else {
      styling.overflowColour = 'rgb(var(--v-theme-cardColor))';
    }
  } else {
    if (props.selected) {
      styling.overflowColour = 'green';
    } else {
      styling.overflowColour = 'green';
    }
  }
}
onBeforeMount(() => {
  if (props.dense) {
    styling.height = 85;
    styling.minHeight = 85;
    styling.marginUnderneath = '5px';
    styling.thumbnailWidth = 96;
    styling.titleBackground = 'unset';
    styling.titleColour = 'rgb(var(--v-theme-text))';
    styling.titleMargin = '7px';
    styling.tagPadding = '0px';
    styling.tagPaddingLeft = 0;
    styling.tagHeight = '30px';
    styling.tagColour = 'unset';
    styling.tagShadow = 'unset';
    styling.imageMargin = '';
    styling.overflowColour = 'rgb(var(--v-theme-cardColor))';
    styling.mainShadow = 'unset';
  }
  checkSelected();
  checkOverflowing();
});
</script>

<style scoped>
.preview-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 136px;
  background: #1a1a1f;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
}
.gradient-active {
  display: flex !important;
}
.gradient-inactive {
  display: none !important;
}
.overflow-overlay {
  position: absolute;
  right: 0px;
  background-color: var(--v-overflow-gradient-base);
  background: var(--v-overflow-gradient-base);
  background: linear-gradient(
    270deg,
    var(--v-overflow-gradient-base) 5%,
    #47474b00 60%
  );
  height: 120%;
  width: 20%;
  opacity: 1;
  z-index: 100;
}
.carditem:hover {
  box-shadow: rgb(0 0 0 / 30%) 1px 1px 24px !important;
  background: rgb(var(--v-theme-wideCardHover)) !important;
  /* transition: all 0.15s ease; */
}

.carditem:hover .widecard-title {
  color: white !important;
}
.carditem:hover .tag-parent {
  color: var(--v-theme-text) !important;
}
.thumbnail-grid-clickable:hover {
  opacity: 0.8;
  transition: opacity 0.2s ease;
}
.widecard-prefix {
  caret-color: rgb(151, 161, 247);
  height: 20px !important;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 11px;
  filter: saturate(100%) contrast(90%) brightness(179%);
  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.8);
  pointer-events: none;
}
</style>
